var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    Unknow row component : "+_vm._s(_vm.row.type)+"\n    "),(_vm.row.type == 'custom')?_c('div',{staticClass:"small"},[_vm._v("\n        Details : "+_vm._s(_vm.row.data.custom)+"\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }